import React from 'react';
import { reportClientError } from '../utils/monitoring';

class ErrorBoundary extends React.Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        reportClientError({
            message: error?.message || 'React render error',
            source: info?.componentStack || 'react-error-boundary',
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <main className="min-h-screen bg-[#050505] px-6 flex items-center justify-center text-center text-white">
                    <div className="max-w-xl">
                        <img src="/ab_logo.png" alt="Alister Bryan" width="512" height="288" decoding="async" className="mx-auto h-16 w-auto mb-10" />
                        <h1 className="text-4xl font-serif-clean uppercase tracking-tight">Algo saiu do quadro</h1>
                        <p className="mt-6 text-white/50 leading-relaxed">Atualize a página para tentar novamente. Se o problema continuar, fale com a gente pelo WhatsApp.</p>
                        <button type="button" onClick={() => window.location.reload()} className="mt-10 border border-cinema-gold px-8 py-4 text-cinema-gold text-[10px] uppercase tracking-[.3em] font-bold hover:bg-cinema-gold hover:text-black transition-colors">Atualizar página</button>
                    </div>
                </main>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
